export default __webpack_public_path__ + "static/media/loading.c7f578dd.gif";